import { delay } from 'helpers/delay';

const MAX_WAIT_TIME = 60000;

export async function waitBeforeRetry(retryAttempt: number): Promise<void> {
  const timeout = Math.min(1000 * 2 ** retryAttempt, MAX_WAIT_TIME);

  await delay(timeout);
}
